export default __webpack_public_path__ + "static/media/line.3f0f9592.svg";